<template>
    <div>
        <!-- web -->
        <div class="goModel" :class="'locale-' + $i18n.locale" v-if="!isWap">
            <transition name="topup-dialog-slide-fade">
                <div class="modal-overlay clickable" v-show="isShowGoDialog" @wheel.prevent @touchmove.prevent>
                    <div
                        class="topup-dialog-pop-bg"
                        ref="goDialogBackground"
                    ></div>
                    <div class="topup-dialog-container">
                        <div
                            class="topup-dialog-content"
                            :style="{
                                backgroundImage: 'url(' + pcDialogBgUrl + ')'
                            }"
                        >
                            <a :href="payUrl" target="_blank">
                                <div
                                    class="topup-dialog-go-btn"
                                    :style="{
                                        backgroundImage:
                                            'url(' + pcGoBtnUrl + ')'
                                    }"
                                >
                                    <!--                      <div class="topup-dialog-btn-bonus" :style="{ backgroundImage: 'url(' + require(`@/assets/${$i18n.locale}/image/model/goModel/bonus.png`) + ')' }"></div>-->
                                </div>
                            </a>
                        </div>
                        <div
                            class="topup-dialog-close-btn"
                            @click="closeGoDialog"
                        ></div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- wap -->
        <div class="mgoModel" :class="'locale-' + $i18n.locale" v-else>
            <transition name="topup-dialog-slide-fade">
                <div class="modal-overlay clickable" v-show="isShowGoDialog" @wheel.prevent @touchmove.prevent>
                    <div
                        class="topup-dialog-pop-bg"
                        ref="goDialogBackground"
                    ></div>
                    <div class="topup-dialog-container">
                        <div
                            class="topup-dialog-content"
                            :style="{
                                backgroundImage:
                                    'url(' + mobileDialogBgUrl + ')'
                            }"
                        >
                            <a :href="payUrl" target="_blank">
                                <div
                                    class="topup-dialog-go-btn"
                                    :style="{
                                        backgroundImage:
                                            'url(' + mobileGoBtnUrl + ')'
                                    }"
                                >
                                    <!--                      <div class="topup-dialog-btn-bonus" :style="{ backgroundImage: 'url(' + require(`@/assets/${this.$i18n.locale}/phoneImage/model/goModel/bonus.png`) + ')' }"></div>-->
                                </div>
                            </a>
                        </div>
                        <div
                            class="topup-dialog-close-btn"
                            @click="closeGoDialog"
                        ></div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "goModel",
    data() {
        return {
            isMobile: false
        };
    },
    props: ["payUrl"],
    computed: {
        ...mapState(["isShowGoDialog"]),
        isWap() {
            return this.$store.state.isWap;
        },
        pcDialogBgUrl() {
            return this.getLocaleAssetUrl("HomePage", "dialog-bg.png");
        },
        pcGoBtnUrl() {
            return this.getLocaleAssetUrl("HomePage", "go.png");
        },
        mobileDialogBgUrl() {
            return this.getLocaleAssetUrl("Wap", "dialog-bg.png");
        },
        mobileGoBtnUrl() {
            return this.getLocaleAssetUrl("Wap", "go.png");
        }
    },
    methods: {
        ...mapActions(["SHOW_GO_DIALOG", "HIDE_GO_DIALOG"]),
        getLocaleAssetUrl(moduleDir, fileName) {
            const locale = this.$i18n && this.$i18n.locale;
            const fallbackLocale =
                (this.$i18n && this.$i18n.fallbackLocale) || "en";
            try {
                return require(`@/assets/${moduleDir}/${locale}/${fileName}`);
            } catch (e) {
                try {
                    return require(`@/assets/${moduleDir}/${fallbackLocale}/${fileName}`);
                } catch (e2) {
                    console.warn(`[i18n-asset] Missing image: ${moduleDir}/${fileName} for locale "${locale}" and fallback "${fallbackLocale}"`);
                    return "";
                }
            }
        },
        closeGoDialog() {
            this.HIDE_GO_DIALOG();
        },
        openGoDialog() {
            this.SHOW_GO_DIALOG();
        }
    },
    mounted() {
        this.openGoDialog();
    }
};
</script>

<style lang="less" scoped>
/* 定义进入和离开的动画，这里的样式的类明是根据html文档里的transition元素的name生成的，值为  name +-enter-active*/
.topup-dialog-slide-fade-enter-active,
.topup-dialog-slide-fade-leave-active {
    transition: all 0.5s ease-in-out; /* 增加到0.5秒 */
}
.topup-dialog-slide-fade-enter, .topup-dialog-fade-leave-to /* 修正类名以匹配Vue的默认行为 */ {
    transform: translateY(-40px);
    opacity: 0;
}
.modal-overlay {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    background-color: transparent; /* 透明背景 */
    pointer-events: none; /* 不阻止点击事件 */
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中 */
}
.clickable {
    pointer-events: auto;
}
.goModel {
    .topup-dialog-pop-bg {
        height: 100vh;
        width: 100vw;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
    }
    .topup-dialog-container {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
    }
    .topup-dialog-content {
        width: 1009px;
        height: 569px;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .topup-dialog-go-btn {
        bottom: -80px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        height: 77px;
        width: 205px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .topup-dialog-btn-bonus {
        position: absolute;
        right: -20px;
        top: -55px;
        height: 116px;
        width: 116px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .topup-dialog-close-btn {
        position: absolute;
        right: 50px;
        top: 20px;
        cursor: pointer;
        height: 35px;
        width: 34px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url("../assets/HomePage/en/close.png");
    }
}
.mgoModel {
    .topup-dialog-pop-bg {
        height: 100vh;
        width: 100vw;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
    }
    .topup-dialog-container {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
    }
    .topup-dialog-content {
        width: 7.5rem;
        height: 4.93rem;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .topup-dialog-go-btn {
        bottom: -0.8rem;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        height: 0.68rem;
        width: 1.782rem;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .topup-dialog-btn-bonus {
        position: absolute;
        right: -0.1rem;
        top: -0.35rem;
        height: 0.66rem;
        width: 0.65rem;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .topup-dialog-close-btn {
        position: absolute;
        right: 0.35rem;
        top: 0.2rem;
        cursor: pointer;
        height: 0.3rem;
        width: 0.3rem;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url("../assets/Wap/en/close.png");
    }
}

</style>
